import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {initNavbarState} from 'actions/navbar.js';

import {spacings, layout, fontSizes, colors} from 'style';

const style={
    content: {
        width: '100%',
        height: '100%',
    },
    body: {
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: spacings.base,
        maxWidth: layout.screenWidth,    
        backgroundColor: 'white',
    },
    message: {
        textAlign: 'center',
        fontSize: fontSizes.h2, 
        lineHeight: '1.5',
        color: colors.themeBlue,
    }
}

class PageNotFound extends Component {

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, menuEnable:true, backButtonEnable:false, mode: 'main'}));
    }

    render() {
      return (
          <div style={style.content}>
            <div style={style.body}>
                <div style={style.message}>{this.props.t('Page Not Found')}</div>
            </div>
          </div>
      );
  }
}

export default connect()(translate()(PageNotFound));



// WEBPACK FOOTER //
// ./src/modules/main/PageNotFound.js